module.exports = __webpack_public_path__ + "img/klop_1kl.91160ff1.jpg";